import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './Scss/index.scss';
import App from './Components/App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd';
import { store, persistor } from './Reducers';
import locale from "antd/es/locale/es_ES";
import { PersistGate } from 'redux-persist/integration/react'
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';

const themes = {
    light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
  };

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ConfigProvider locale={locale}>
                <ThemeSwitcherProvider themeMap={themes} defaultTheme='light'>
                    <App />
                </ThemeSwitcherProvider>
            </ConfigProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root'));

serviceWorker.unregister();
